import React, { Component } from 'react'
import AttendancesPV from './AttendancesPV'
import AuthA from '../../store/actions/AuthA'
import QuarterA from '../../store/actions/QuarterA'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import constantCase from 'constant-case'
import paramCase from 'param-case'
import {connect} from 'react-redux'
import { isValidQuarter } from '../../utils/quarterUtils'

const _ = {
    sortBy: sortBy,
    find: find
}

const changeCase = {
  constantCase: constantCase,
  paramCase: paramCase,
}

class AttendancesPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attendances: [],
      section: [],
      sectionId: '',
      column: null,
      direction: null,
      sectionStudents: [],
      error: false,
      success: false,
      fileName: '',
      attendanceSheet: null,
      areAttendancesSaved: false,
      daysOfSchool: [],
      dirtyInput: false,
      open: false,
      created: [],
      checked: [],
      reviewed: [],
      sections: []
    };
    this.getAttendances = this.getAttendances.bind(this);
    this.getSectionStudents = this.getSectionStudents.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleUpdateSectionDetails = this.handleUpdateSectionDetails.bind(this);
  }

  getAttendances(sectionId) {
    const { sectionStudents } = this.state;
    axios.get(process.env.REACT_APP_URL+'/attendances?filter[where][active]=true&filter[where][sectionId]='+sectionId)
    .then(response => {
      this.setState({ attendances: response.data}, () => {
        if (response.data.length !== 0) {
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);
            const attendance = _.find(response.data, {
              sectionStudentId: sectionStudent.sectionStudentId
            });

            // Helper to convert 0 to empty string for display
            const displayValue = (val) => (val === 0 || val === null || val === undefined) ? '' : val;

            if (attendance != null) {
              this.setState({
                [`${studentVariable}-JUN`]: displayValue(attendance.jun),
                [`${studentVariable}-JUL`]: displayValue(attendance.jul),
                [`${studentVariable}-AUG`]: displayValue(attendance.aug),
                [`${studentVariable}-SEP`]: displayValue(attendance.sep),
                [`${studentVariable}-OCT`]: displayValue(attendance.oct),
                [`${studentVariable}-NOV`]: displayValue(attendance.nov),
                [`${studentVariable}-DEC`]: displayValue(attendance.dec),
                [`${studentVariable}-JAN`]: displayValue(attendance.jan),
                [`${studentVariable}-FEB`]: displayValue(attendance.feb),
                [`${studentVariable}-MAR`]: displayValue(attendance.mar),
                [`${studentVariable}-APR`]: displayValue(attendance.apr),
                [`${studentVariable}-MAY`]: displayValue(attendance.may),
                [`${studentVariable}-TOTAL`]: displayValue(attendance.total),
                [`${studentVariable}-JUNTardy`]: displayValue(attendance.junTardy),
                [`${studentVariable}-JULTardy`]: displayValue(attendance.julTardy),
                [`${studentVariable}-AUGTardy`]: displayValue(attendance.augTardy),
                [`${studentVariable}-SEPTardy`]: displayValue(attendance.sepTardy),
                [`${studentVariable}-OCTTardy`]: displayValue(attendance.octTardy),
                [`${studentVariable}-NOVTardy`]: displayValue(attendance.novTardy),
                [`${studentVariable}-DECTardy`]: displayValue(attendance.decTardy),
                [`${studentVariable}-JANTardy`]: displayValue(attendance.janTardy),
                [`${studentVariable}-FEBTardy`]: displayValue(attendance.febTardy),
                [`${studentVariable}-MARTardy`]: displayValue(attendance.marTardy),
                [`${studentVariable}-APRTardy`]: displayValue(attendance.aprTardy),
                [`${studentVariable}-MAYTardy`]: displayValue(attendance.mayTardy),
                [`${studentVariable}-TOTALTardy`]: displayValue(attendance.totalTardy),
                areAttendancesSaved: true
              })
              return true;
            } else {
              this.setState({
                [`${studentVariable}-JUN`]: '',
                [`${studentVariable}-JUL`]: '',
                [`${studentVariable}-AUG`]: '',
                [`${studentVariable}-SEP`]: '',
                [`${studentVariable}-OCT`]: '',
                [`${studentVariable}-NOV`]: '',
                [`${studentVariable}-DEC`]: '',
                [`${studentVariable}-JAN`]: '',
                [`${studentVariable}-FEB`]: '',
                [`${studentVariable}-MAR`]: '',
                [`${studentVariable}-APR`]: '',
                [`${studentVariable}-MAY`]: '',
                [`${studentVariable}-TOTAL`]: '',
                [`${studentVariable}-JUNTardy`]: '',
                [`${studentVariable}-JULTardy`]: '',
                [`${studentVariable}-AUGTardy`]: '',
                [`${studentVariable}-SEPTardy`]: '',
                [`${studentVariable}-OCTTardy`]: '',
                [`${studentVariable}-NOVTardy`]: '',
                [`${studentVariable}-DECTardy`]: '',
                [`${studentVariable}-JANTardy`]: '',
                [`${studentVariable}-FEBTardy`]: '',
                [`${studentVariable}-MARTardy`]: '',
                [`${studentVariable}-APRTardy`]: '',
                [`${studentVariable}-MAYTardy`]: '',
                [`${studentVariable}-TOTALTardy`]: '',
                areAttendancesSaved: false
              })

              return true;
            }
          })
        } else {
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);

            this.setState({
              [`${studentVariable}-JUN`]: '',
              [`${studentVariable}-JUL`]: '',
              [`${studentVariable}-AUG`]: '',
              [`${studentVariable}-SEP`]: '',
              [`${studentVariable}-OCT`]: '',
              [`${studentVariable}-NOV`]: '',
              [`${studentVariable}-DEC`]: '',
              [`${studentVariable}-JAN`]: '',
              [`${studentVariable}-FEB`]: '',
              [`${studentVariable}-MAR`]: '',
              [`${studentVariable}-APR`]: '',
              [`${studentVariable}-MAY`]: '',
              [`${studentVariable}-TOTAL`]: '',
              [`${studentVariable}-JUNTardy`]: '',
              [`${studentVariable}-JULTardy`]: '',
              [`${studentVariable}-AUGTardy`]: '',
              [`${studentVariable}-SEPTardy`]: '',
              [`${studentVariable}-OCTTardy`]: '',
              [`${studentVariable}-NOVTardy`]: '',
              [`${studentVariable}-DECTardy`]: '',
              [`${studentVariable}-JANTardy`]: '',
              [`${studentVariable}-FEBTardy`]: '',
              [`${studentVariable}-MARTardy`]: '',
              [`${studentVariable}-APRTardy`]: '',
              [`${studentVariable}-MAYTardy`]: '',
              [`${studentVariable}-TOTALTardy`]: '',
              areAttendancesSaved: false
            })

            return true;
          })
        }
      });
    });
  }

  getSection = (sectionId) => {
    axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true&filter[include]=details&filter[where][sectionId]='+sectionId)
    .then(async(response) => {
      await this.getSectionDetailsForChecking();
      await this.getSectionDetailsForReview();
      await this.getSectionDetailsForApproval();
      await this.getSections();
      this.setState({ section: response.data});
    });
  }

  getSectionDetailsForChecking = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Created&filter[where][type]=attendance&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({created: response.data})
    });
  }

  getSectionDetailsForReview = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Checked&filter[where][type]=attendance&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({checked: response.data})
    });
  }

  getSectionDetailsForApproval = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Reviewed&filter[where][type]=attendance&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({reviewed: response.data})
    });
  }

  getSections = async() => {
    await axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true')
    .then(response => {
      this.setState({ sections: response.data });
    });
  }

  getSectionStudents(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sectionStudents?filter[where][active]=true&filter[include]=student&filter[where][sectionId]='+sectionId)
    .then(response => {
      const sorted = _.sortBy(response.data, function(o){return [o.student.lastName, o.student.firstName]})
      this.setState({ sectionStudents: sorted }, () => {
        // this.handleSort('name')
        this.getAttendances(this.state.sectionId);
      });
    });
  }

  getDaysOfSchool= (id) => {
    axios.get(process.env.REACT_APP_URL+'/schoolYears/'+id+'/days')
    .then(response => {
      this.setState({
        daysOfSchool: response.data
      });
    })
    .catch(function (error) {
      // handle error
      console.log(error);
      // this.setState({forSubmission: true})
    })
  }

  handleApprovalOpen = () => {
    this.setState({
      open: true
    })
  }

  handleApprovalClose = () => this.setState({
    open: false
  })

  handleClickTableCell = (month) => {
    const {sectionStudents, daysOfSchool} = this.state;
    sectionStudents.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      const studentVariable = changeCase.constantCase(studentName);
      const monthVariable = month.toLowerCase();
      this.setState({
        [`${studentVariable}-${month}`]: daysOfSchool[`${monthVariable}Days`],
        dirtyInput: true
      });
      return true;
    })
  }

  handleSort(clickedColumn) {
    const { column, sectionStudents, direction } = this.state
    if (column !== clickedColumn) {
      if(clickedColumn === 'name') {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, function(o){return o.student.lastName}),
          direction: 'ascending',
        })
        return
      } else {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, [clickedColumn]),
          direction: 'ascending',
        })
        return
      }
    }
    this.setState({
      sectionStudents: sectionStudents.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleChange = (e, { name, value }) => {
    this.setState({[name]: value, dirtyInput: true})
  }

  handleUpdateSectionDetails(data, id) {
    const url = process.env.REACT_APP_URL+'/sectionDetails/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {
        this.setState({open: false}, this.getSection(this.state.sectionId))
      })
      .catch(err => console.log(err));
  }

  handleSubmit = () => {
    const {sectionStudents} = this.state;
    // Validations

    sectionStudents.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      const studentVariable = changeCase.constantCase(studentName);

      let total = 0, totalTardy = 0, jun = 0, jul = 0, aug = 0, sep = 0, oct = 0,
      nov = 0, dec = 0, jan = 0, feb = 0, mar = 0, apr = 0, may = 0;
      const months = ['JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR', 'APR', 'MAY'];
      months.map((month, index) => {
        // const quotient = Math.floor(parseInt(this.state[`${studentVariable}-${month}Tardy`]) / 3);
        switch (month) {
          case 'JUN':
            jun = this.state[`${studentVariable}-JUN`];
            break;
          case 'JUL':
            jul = this.state[`${studentVariable}-JUL`];
            break;
          case 'AUG':
            aug = this.state[`${studentVariable}-AUG`];
            break;
          case 'SEP':
            sep = this.state[`${studentVariable}-SEP`];
            break;
          case 'OCT':
            oct = this.state[`${studentVariable}-OCT`];
            break;
          case 'NOV':
            nov = this.state[`${studentVariable}-NOV`];
            break;
          case 'DEC':
            dec = this.state[`${studentVariable}-DEC`];
            break;
          case 'JAN':
            jan = this.state[`${studentVariable}-JAN`];
            break;
          case 'FEB':
            feb = this.state[`${studentVariable}-FEB`];
            break;
          case 'MAR':
            mar = this.state[`${studentVariable}-MAR`];
            break;
          case 'APR':
            apr = this.state[`${studentVariable}-APR`];
            break;
          case 'MAY':
            may = this.state[`${studentVariable}-MAY`];
            break;
          default:
            console.log('no month')
            break;
        }
        // Handle empty strings by converting to 0
        const monthValue = this.state[`${studentVariable}-${month}`];
        const monthTardyValue = this.state[`${studentVariable}-${month}Tardy`];
        const numValue = (monthValue === '' || monthValue === null || monthValue === undefined) ? 0 : parseInt(monthValue);
        const numTardyValue = (monthTardyValue === '' || monthTardyValue === null || monthTardyValue === undefined) ? 0 : parseInt(monthTardyValue);

        total = parseInt(total) + numValue;
        totalTardy = parseInt(totalTardy) + numTardyValue;
        return true;
      })

      const sectionStudentId = sectionStudent.sectionStudentId;
      const sectionId = this.state.sectionId;

      // Convert empty strings to 0 for database storage
      const getValue = (val) => val === '' || val === undefined || val === null || isNaN(val) ? 0 : val;

      const data = {
        sectionStudentId: sectionStudentId,
        sectionId: sectionId,
        jun:  getValue(jun),
        jul:  getValue(jul),
        aug:  getValue(aug),
        sep:  getValue(sep),
        oct:  getValue(oct),
        nov:  getValue(nov),
        dec:  getValue(dec),
        jan:  getValue(jan),
        feb:  getValue(feb),
        mar:  getValue(mar),
        apr:  getValue(apr),
        may:  getValue(may),
        total:  getValue(total),
        junTardy:  getValue(this.state[`${studentVariable}-JUNTardy`]),
        julTardy:  getValue(this.state[`${studentVariable}-JULTardy`]),
        augTardy:  getValue(this.state[`${studentVariable}-AUGTardy`]),
        sepTardy:  getValue(this.state[`${studentVariable}-SEPTardy`]),
        octTardy:  getValue(this.state[`${studentVariable}-OCTTardy`]),
        novTardy:  getValue(this.state[`${studentVariable}-NOVTardy`]),
        decTardy:  getValue(this.state[`${studentVariable}-DECTardy`]),
        janTardy:  getValue(this.state[`${studentVariable}-JANTardy`]),
        febTardy:  getValue(this.state[`${studentVariable}-FEBTardy`]),
        marTardy:  getValue(this.state[`${studentVariable}-MARTardy`]),
        aprTardy:  getValue(this.state[`${studentVariable}-APRTardy`]),
        mayTardy:  getValue(this.state[`${studentVariable}-MAYTardy`]),
        totalTardy:  getValue(totalTardy),
      }

      const url = process.env.REACT_APP_URL+'/attendances/upsertWithWhere?where={"sectionId":"'+sectionId+'","sectionStudentId":"'+sectionStudentId+'"}';
      axios
        .request({
          method: 'post',
          url: url,
          data: data
        })
        .then(response => {
          if (key === sectionStudents.length-1) {
            this.setState({success: true}, () => this.getAttendances(sectionId));
          }
        })
        .catch(err => console.log(err));

      return true;
    })
    this.setState({success: true, error: false, dirtyInput: false, open: true})
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'Attendance'});

    const sectionId = this.props.match.params.sectionId;
    const schoolYearId = this.props.match.params.schoolYearId;
    const params = new URLSearchParams(this.props.location.search);
    const quarter = params.get('quarter');
    
    // Update Redux quarter state if quarter is provided in URL
    if (quarter && isValidQuarter(parseInt(quarter))) {
      this.props.quarterActions.setCurrentQuarter(parseInt(quarter));
    }
    
    this.setState({sectionId: sectionId, schoolYearId: schoolYearId}, () => {
      this.getSectionStudents(sectionId);
      this.getSection(sectionId);
      this.getDaysOfSchool(schoolYearId);
    })

  }

  componentDidUpdate(prevProps) {
    const sectionId = this.props.match.params.sectionId;
    const schoolYearId = this.props.match.params.schoolYearId;
    const prevSectionId = prevProps.match.params.sectionId;
    const prevSchoolYearId = prevProps.match.params.schoolYearId;
    const params = new URLSearchParams(this.props.location.search);
    const quarter = params.get('quarter');

    // Only update if route params actually changed
    const hasChanged = sectionId !== prevSectionId ||
                      schoolYearId !== prevSchoolYearId ||
                      this.props.currentQuarter !== prevProps.currentQuarter;

    if (!hasChanged) {
      return; // Prevent duplicate API calls
    }

    // Update Redux quarter state if quarter is provided in URL
    if (quarter && isValidQuarter(parseInt(quarter))) {
      this.props.quarterActions.setCurrentQuarter(parseInt(quarter));
    }

    // Clear any existing timeout
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    // Add 1 second delay before making API calls
    this.updateTimeout = setTimeout(() => {
      this.setState({sectionId: sectionId, schoolYearId: schoolYearId}, () => {
        this.getSectionStudents(sectionId);
        this.getSection(sectionId);
        this.getDaysOfSchool(schoolYearId);
      });
    }, 1000);
  }

  render() {
    return (
      <AttendancesPV
        auth={this.props.auth}
        username={this.props.username}
        userType={this.props.userType}
        userId={this.props.userId}
        column={this.state.column}
        direction={this.state.direction}
        section={this.state.section}
        sectionStudents={this.state.sectionStudents}
        error={this.state.error}
        success={this.state.success}
        areAttendancesSaved={this.state.areAttendancesSaved}
        daysOfSchool={this.state.daysOfSchool}
        quarter={this.props.currentQuarter}
        dirtyInput={this.state.dirtyInput}
        open={this.state.open}
        created={this.state.created}
        checked={this.state.checked}
        reviewed={this.state.reviewed}
        sections={this.state.sections}
        schoolYearId={this.state.schoolYearId}
        {...this.state}
        handleApprovalOpen={this.handleApprovalOpen}
        handleApprovalClose={this.handleApprovalClose}
        handleClickTableCell={this.handleClickTableCell}
        handleSort={this.handleSort}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleUpdateSectionDetails={this.handleUpdateSectionDetails}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch),
    quarterActions: QuarterA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    username: state.AuthR.username,
    userType: state.AuthR.userType,
    userId: state.AuthR.userId,
    currentQuarter: state.QuarterR.currentQuarter,
    schoolYearId: state.QuarterR.schoolYearId
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AttendancesPC);
